import './CoralDomain.scss'

import { useIsWindowBiggerThan } from '@bob/library'
import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { mapCoralWebDomain } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { CoralDomainFlipCard } from '../../../coral-library/cards/FlipCards/CoralDomainFlipCard/CoralDomainFlipCard'

type CoralDomainProps = ReturnType<typeof mapCoralWebDomain>

export const CoralDomain: FC<CoralDomainProps> = (props) => {
  const isTablet = useIsWindowBiggerThan(719)
  const isDesktop = useIsWindowBiggerThan(1079)
  const shouldRenderSlider = isTablet && !isDesktop
  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-domain'}>
        <CoralHeading description={props.description} header={props.header} headerTag={'h2'} />

        {shouldRenderSlider ? (
          <div className={'coral-domain__container-slider'}>
            <CoralCardsSlider forceRow={true}>
              {props.flip_cards.map((card, id) => {
                const defaultTimes = [0.5, 0.6, 1.5, 0.55]
                const defaultTime = defaultTimes[id] ?? 0
                return (
                  <div key={id}>
                    <CoralDomainFlipCard {...card} animationStartTime={defaultTime} />
                    <div className={'coral-domain__domain-description'}>
                      {card.domainDescription}
                    </div>
                  </div>
                )
              })}
            </CoralCardsSlider>
          </div>
        ) : (
          <div className={'coral-domain__container'}>
            {props.flip_cards.map((card, id) => {
              const defaultTimes = [0.5, 0.6, 1.5, 0.55]
              const defaultTime = defaultTimes[id] ?? 0
              return (
                <div key={id}>
                  <CoralDomainFlipCard {...card} animationStartTime={defaultTime} />
                  <div className={'coral-domain__domain-description'}>{card.domainDescription}</div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
